import React, { useEffect, useState } from 'react';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import LoadOrError from 'ui/LoadOrError';
import Spinner from 'ui/Spinner';
import TagRow from './TagRow';

/* eslint-disable no-alert */

const TagsIndex = ({ hasLearningLibrary, canCreateEditTags }) => {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    request
      .get(routes.TAGS)
      .then(result => {
        setTags(result.tags);
        setLoading(false);
        setError(false);
      })
      .catch(() => setError(true));
  }, []);

  const deleteTag = tag => {
    if (window.confirm(t('tags.confirm_destroy', { tag_name: tag.name }))) {
      setLoading(true);

      request
        .delete(routes.TAGS_DELETE(tag.id))
        .then(() => {
          setLoading(false);
          setTags(tags.filter(({ id }) => id !== tag.id));
        })
        .catch(() => setError(true));
    }
  };

  return (
    <div
      className="panel row tags"
      data-back-title={t('tags.table.all')}
      data-back-level="0"
    >
      <header className="panel-header-underlined">
        <h1 className="panel-title">{t('tags.table.all')}</h1>
      </header>
      <div className="panel_body">
        <div className="DataTable TagsTable">
          <div className="DataTable-thead">
            <div className="DataTable-th DataTable-name">
              {t('tags.table.name')}
            </div>

            {hasLearningLibrary && (
              <div className="DataTable-th">{t('learn.tag_title')}</div>
            )}

            <div className="DataTable-th DataTable-description">
              {t('tags.table.cover_image')}
            </div>

            <div className="DataTable-th DataTable-description">
              {t('tags.table.description')}
            </div>

            <div className="DataTable-th DataTable-actions" />
          </div>

          <LoadOrError
            loadingComponent={
              <div className="DataTable-tr">
                <div className="DataTable-td">
                  <Spinner />
                </div>
              </div>
            }
            loading={loading}
            error={error}
          >
            {() =>
              tags.map(tag => (
                <TagRow
                  key={tag.id}
                  tag={tag}
                  deleteTag={() => deleteTag(tag)}
                  canCreateEditTags={canCreateEditTags}
                  hasLearningLibrary={hasLearningLibrary}
                />
              ))
            }
          </LoadOrError>
        </div>

        {canCreateEditTags && (
          <a
            id="new_tag_link"
            href={routes.TAGS_NEW}
            className="btn btn-secondary"
          >
            {t('tags.table.new')}
          </a>
        )}
      </div>
    </div>
  );
};

export default props => <TagsIndex {...props} />;
